import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontFamily: 'Inter',
    color: 'white',
    marginTop:'25px'
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  textInputWrapper: {
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500
  },
  textField: {
    marginTop: "8px",
    background: 'white',
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  textFieldError: {
    "& .MuiOutlinedInput-root": {
      color: "red",
    }
  },
  inputHelper: {
    color: theme.palette.grey.main,
    fontSize: '12px',
  },
}));

export default useStyles;